import type { FaireProductEntity } from "../../entity_types/product";

export const p_mu9683qywm: FaireProductEntity = {
  token: "p_mu9683qywm",
  type: "product",
  name: "Rustic Metal Bees for Wall Hanging or Tabletop, Set of 2",
  brandName: "Artisan Metal Art INC",
  imageUrl:
    "https://cdn.faire.com/fastly/c95244209dcaf5dd54e8cc4a3a80044be5d5384b64d4ce5640cfe5ceaf4645da.jpeg",
  priceDollars: 12.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/f62d91c197eb185109ec50a2f048554b48a04537a5d83e182e507596979be5d8.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
